// @flow 

import React from "react";
import ImageOrPdfUploadWithPreview from "../../../../components/general/imageFileUpload/imageOrPdfUploadWithPreview";
import useFileFromApiForPreview from "../../../../hooks/useFileFromApiForPreview";

type Props = {
	
};

const TemplateImageUpload = (props: Props) => {
	const {exhibitionId} = props
	const {
		file,
		loading,
		loadingDelete,
		deleteFile,
		uploadFile
	} = useFileFromApiForPreview({
		fetchFileUrl: `exhibition/getmarketingkitlogo/${exhibitionId}`,
		uploadFileUrl: `exhibition/updatemarketingkitlogo/${exhibitionId}`,
		deleteFileUrl: `exhibition/deletemarketingkitlogo/${exhibitionId}`,
	})
	
	return (
		<ImageOrPdfUploadWithPreview
			loading={loading}
			loadingDelete={loadingDelete}
			deleteFile={deleteFile}
			uploadFile={uploadFile}
			file={file}
			allowedFiles={{'image/png': []}}
		/>
	);
};

export default TemplateImageUpload